<template>
  <router-view
    :ctlData="ctlData"
    :isLoadingCtlData="isLoadingCtlData"
    class="mt-24"
    @update-questionnaire="updateQuestionnaire"
    @close-account="closeAccount"
  />
</template>

<script lang="ts">
import { UPDATE_QUESTIONNAIRE_RESULT, CLOSE_ACCOUNT } from '../../../graphql/account/mutations';
import PublicApiClient from '@/lib/PublicApiClient';
import CloseTheLoop from '@/lib/public_api/CloseTheLoop';

export default {
  name: 'Deactivate',
  data() {
    return {
      ctlData: null as CloseTheLoop | null,
      isLoadingCtlData: true,
    };
  },
  async mounted() {
    try {
      const c = new PublicApiClient();

      // Add a timeout wrapper to prevent infinite loading
      const timeoutPromise = new Promise((_, reject) => {
        setTimeout(() => reject(new Error('API call timeout after 8 seconds')), 8000);
      });

      const data = await Promise.race([c.closeTheLoopData(), timeoutPromise]);
      this.ctlData = data || null;
      this.isLoadingCtlData = false;
    } catch (_error) {
      this.ctlData = null;
      this.isLoadingCtlData = false;
    }
  },
  methods: {
    updateQuestionnaire(data) {
      this.$apollo
        .mutate({
          mutation: UPDATE_QUESTIONNAIRE_RESULT,
          variables: {
            input: {
              matchSuccessful: data.matchSuccessful,
              matchedMembers: data.matchedMembers,
              matchedMemberNotDisplayed: data.matchedMemberNotDisplayed,
              selectedNotSuccessfulReasons: data.selectedNotSuccessfulReasons,
            },
          },
        })
        .catch((e) => {
          console.error(e);
        });
    },
    closeAccount() {
      this.$apollo
        .mutate({
          mutation: CLOSE_ACCOUNT,
        })
        .then((payload) => {
          if (payload.data.closeAccount.isSuccessful) {
            window.location.href = `/logout?return_path=${encodeURI('/account/deactivation/confirmation')}`;
          }
        })
        .catch((e) => {
          console.error(e);
        });
    },
  },
};
</script>
